import { EyeOff } from 'lucide-react';
import { recognitionWarningMessage, type NextSongLockState, type RecognitionWarningLevel } from '../../utils/recognitionWarnings';

interface RecognitionWarningProps {
  level: RecognitionWarningLevel;
  playerLabel: string;
  lockState: NextSongLockState;
  removing: boolean;
  onRemove: () => void;
}

export function RecognitionWarning({ level, playerLabel, lockState, removing, onRemove }: RecognitionWarningProps) {
  const serious = level === 'serious';
  const message = recognitionWarningMessage(level, lockState, playerLabel);

  return (
    <div
      data-testid={`recognition-warning-${level}`}
      className={`flex items-start gap-2 mt-2 px-2 py-1.5 rounded-md border-l-4 text-xs ${
        serious
          ? 'border-l-red-500 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300'
          : 'border-l-sky-500 bg-sky-50 dark:bg-sky-900/20 text-sky-700 dark:text-sky-300'
      }`}
    >
      <EyeOff className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
      <span className="flex-1">{message}</span>
      <button
        type="button"
        onClick={onRemove}
        disabled={removing}
        className="underline font-medium whitespace-nowrap disabled:opacity-50"
      >
        Remove flag
      </button>
    </div>
  );
}
